var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"messageMrg"}},[_c('TopList',{attrs:{"navList":_vm.navList},on:{"setType":_vm.setType}}),(_vm.type === 0 || _vm.type === 1)?_c('All'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }